import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	notCompletedTaskCountNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.not-completed-task-count-non-final',
		defaultMessage: '{count, plural, one {{count} task} other {{count} tasks}} left',
		description: 'Not completed task count',
	},
	taskTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.task-title-non-final',
		defaultMessage: 'Things to do',
		description: 'Task title',
	},
	usersAndRolesTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.users-and-roles-title-non-final',
		defaultMessage: 'Users and roles',
		description: 'Transition home left hand side users and roles step title',
	},
	usersAndRolesDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.users-and-roles-description-non-final',
		defaultMessage:
			'Learn how to manage users and roles, and resolve any detected errors to ensure your team members have access to Jira Service Management.',
		description: 'Transition home left hand side users and roles step description',
	},
	alertsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.alerts-title-non-final',
		defaultMessage: 'Alerts',
		description: 'Transition home left hand side alerts step title',
	},
	alertsAndOnCallTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.alerts-and-on-call-title-non-final',
		defaultMessage: 'Alerts and on-call',
		description: 'The title of alerts and on-call step in the transition home left side',
	},
	alertsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.alerts-description-non-final',
		defaultMessage:
			"Check out what's new in the redesigned alerting experience in Jira Service Management.",
		description: 'Transition home left hand side alerts step description',
	},
	notificationsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.notifications-title-non-final',
		defaultMessage: 'Notifications',
		description: 'Transition home left hand side notifications step title',
	},
	notificationsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.notifications-description-non-final',
		defaultMessage:
			'Learn about the changes to your notifications, and set up Jira Cloud as your primary contact method for push notifications.',
		description: 'Transition home left hand side notifications step description',
	},
	teamsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.teams-title-non-final',
		defaultMessage: 'Launch operations for your team',
		description: 'Transition home left hand side teams step title',
	},
	teamsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.teams-description-non-final',
		defaultMessage:
			'Discover how to launch and manage operations for your teams in Jira Service Management.',
		description: 'Transition home left hand side teams step description',
	},
	chatToolsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.chat-tools-title-non-final',
		defaultMessage: 'Chat tools',
		description: 'Transition home left hand side chat tools step title',
	},
	chatToolsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.chat-tools-description-non-final',
		defaultMessage:
			'Learn how chat tools help with alerting, and set up your Opsgenie chat integrations in Jira Service Management.',
		description: 'Transition home left hand side chat tools step description',
	},
	automateAlertAndIncidentResponseTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-title-non-final',
		defaultMessage: 'Automate your alert and incident response',
		description:
			'Transition home left hand side automate alert and incident response step title for optimal tooling',
	},
	automateAlertAndIncidentResponseDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.automate-alert-and-incident-response-description-non-final',
		defaultMessage:
			'Learn how to set up automation for your alerts and incidents in Jira Service Management.',
		description:
			'Transition home left hand side automate alerts and incident response step description for optimal tooling',
	},
	integrationsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.integrations-title-non-final',
		defaultMessage: 'Integrations',
		description: 'Transition home left hand side integrations step title',
	},
	integrationsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.integrations-description-non-final',
		defaultMessage:
			'Learn where to find your alerting integrations and how to manage them in Jira Service Management.',
		description: 'Transition home left hand side integrations step description',
	},
	deprecatedOnesTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.deprecated-ones-title-non-final',
		defaultMessage: "What's left behind in Opsgenie",
		description: 'Transition home left hand side deprecated features step title',
	},
	deprecatedOnesDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.deprecated-ones-description-non-final',
		defaultMessage: "Review which parts of Opsgenie aren't moving to Jira Service Management.",
		description: 'Transition home left hand side deprecated features step description',
	},
	heartbeatsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.heartbeats-title-non-final',
		defaultMessage: 'Heartbeats',
		description: 'Transition home left hand side heartbeats step title',
	},
	heartbeatsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.heartbeats-description-non-final',
		defaultMessage: 'Learn how to manage your heartbeats in Jira Service Management.',
		description: 'Transition home left hand side heartbeats step description',
	},
	findWhatYouAreLookingForTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-title-non-final',
		defaultMessage: "Find what you're looking for",
		description: 'Transition home left hand side find what you are looking for step title',
	},
	findWhatYouAreLookingForDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.find-what-you-are-looking-for-description-non-final',
		defaultMessage:
			'View a list of shortcuts for you to quickly navigation between your operations work in Jira Service Management.',
		description: 'Transition home left hand side find what you are looking for step description',
	},
	incidentsTitleNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.incidents-title-non-final',
		defaultMessage: 'Incidents',
		description: 'Transition home left hand side incidents step title',
	},
	incidentsDescriptionNonFinal: {
		id: 'eoc-changeboarding.common.transition-home.step.incidents-description-non-final',
		defaultMessage:
			'Check out how the incident management experience looks like in Jira Service Management.',
		description: 'Transition home left hand side incidents step description',
	},
});
